var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-upload',{staticClass:"avatar-uploader",style:({
    height: _vm.size + 'px',
    width: _vm.size + 'px',
    '--border-radius': _vm.borderRadius,
  }),attrs:{"action":_vm.upload.path,"before-upload":_vm.beforeAvatarUpload,"headers":_vm.upload.header,"on-error":_vm.handleAvatarError,"on-success":_vm.handleAvatarSuccess,"show-file-list":false,"name":"uploadFile"}},[(_vm.imagePath)?_c('i-image',{attrs:{"height":_vm.size + 'px',"src":_vm.getImageUrl(_vm.imagePath),"width":_vm.size + 'px'}}):_c('v-icon',[_vm._v("mdi-upload")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }